import React from 'react'
import './ConfirmationModal.css'

const ConfirmationModal = ({
    isOpen,
    onClose,
    actionBtnText,
    onAction,
    title,
    body
}) => {
    if (!isOpen) return null

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose()
        }
    }

    const handleAction = () => {
        onAction()
        onClose()
    }

    return (
        <div className="confirmation-modal-overlay" onClick={handleBackdropClick}>
            <div className="confirmation-modal">
                <div className="confirmation-modal-header">
                    <h2 className="confirmation-modal-title">{title}</h2>
                    <button
                        className="confirmation-modal-close-btn"
                        onClick={onClose}
                        aria-label="Close modal"
                    >
                        ×
                    </button>
                </div>

                <div className="confirmation-modal-body">
                    <p className="confirmation-modal-message">{body}</p>
                </div>

                <div className="confirmation-modal-footer">
                    <button
                        className="confirmation-modal-btn confirmation-modal-btn-cancel"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="confirmation-modal-btn confirmation-modal-btn-action"
                        onClick={handleAction}
                    >
                        {actionBtnText}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmationModal
